'use client';

import { type FC } from 'react';
import CircledIcon from './CircledIcon';
import Yellow from '@wwe-portal/ui/assets/images/roster/ability/Yellow.webp';
import Blue from '@wwe-portal/ui/assets/images/roster/ability/Blue.webp';
import Red from '@wwe-portal/ui/assets/images/roster/ability/Red.webp';
import Green from '@wwe-portal/ui/assets/images/roster/ability/Green.webp';
import Purple from '@wwe-portal/ui/assets/images/roster/ability/Purple.webp';
import Black from '@wwe-portal/ui/assets/images/roster/ability/Black.webp';

export interface Props {
  gemKey: string;
  className?: string;
}

export const renderWrestlerGemImage = (key: string) => {
  switch (key) {
    case 'Yellow':
      return Yellow;
    case 'Blue':
      return Blue;
    case 'Red':
      return Red;
    case 'Green':
      return Green;
    case 'Purple':
      return Purple;
    case 'Black':
      return Black;
    default:
      return;
  }
};

export const GemImage: FC<Props> = ({ gemKey, className }) => {
  return (
    <CircledIcon
      icon={renderWrestlerGemImage(gemKey) ?? ''}
      className={className}
    />
  );
};
